import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { IGlobalState } from '../../store';
import { ILocation } from '../../store/reducers/locations';
import { FORM_NAME, PAGE, PAGE_CONTEXT } from '../../constants';
import { getRegionId, mergeFormData } from '../../helpers';
import { getSelectionAbExperimentAnalytics } from '../../helpers/experiments';
import { NotFound } from '../restore/not.found';
import { Experiments } from '../../store/reducers/abData';
import { clearFormData, extendFbPayload, extendFormStore, setPageContext } from '../../store/reducers/formStore';
import { MainSkeleton } from '../landing.common/main.skeleton';
import { ProductHeader } from '../landing/product.header';
import { ClientTraceContext } from '../../helpers/clientTraceContext';
import { AnchorWrapper, Wrapper } from './ui/form/index.styles';
import { View } from './creator';

type OwnProps = {
    userId?: string;
    autoRun?: boolean;
    isMobile: boolean;
    isTablet: boolean;
    /** @deprecated use memoryData instead */
    formData?: FE.FormData;
    memoryData: FE.FormData;
    setShowLanding: (value: boolean) => void;
    requestId?: number;
    /** @deprecated */
    authImport?: boolean;
    withNewMobileLanding?: boolean;
    cookies?: Record<string, string>;
    headline?: string;
    //TODO: переделать при рефакторинге LANDING и выдачи
    guid?: string;
    currentStepOnMount?: number;
    oncePassedStepsOnMount?: Array<string>;
    disabledFields?: Array<string>;
    showProduct?: boolean;
};

type ConnectedProps = {
    region: ILocation;
    page: ValuesOf<typeof PAGE>;
    experiments: Experiments;
    areExperimentsDefault: boolean;
    hasUnsignedDocs: boolean;
    isLoggedInSilent: boolean;
    isLoggedIn: boolean;
};

type Props = OwnProps & ConnectedProps & DispatchProp;

interface State {
    mounted: boolean;
}

class LandingFormComponent extends React.Component<Props, State> {
    state: State = {
        mounted: false,
    };

    componentDidMount() {
        const { dispatch, formData, memoryData } = this.props;
        dispatch(clearFormData(mergeFormData(memoryData, formData || {})));
        dispatch(setPageContext(PAGE_CONTEXT.DEFAULT));

        this.setFbPayload({ onMount: true });
        this.setState({ mounted: true });
    }

    componentDidUpdate(prevProps: Readonly<Props>) {
        const prevPropsHash = JSON.stringify({ ...prevProps, formData: null, memoryData: null });
        const currentPropsHash = JSON.stringify({ ...this.props, formData: null, memoryData: null });

        if (prevPropsHash !== currentPropsHash) {
            this.setFbPayload();
        }
    }

    setFbPayload = ({ onMount = false } = {}) => {
        const {
            isTablet,
            isMobile,
            page,
            userId,
            region,
            headline,
            cookies: { _ga: googleAnalyticId, _ym_uid: yandexMetricsId } = {},
            autoRun,
            guid,
            experiments,
            areExperimentsDefault,
            dispatch,
            oncePassedStepsOnMount: oncePassedSteps = [],
            disabledFields = [],
        } = this.props;

        const device_type = isMobile ? 'Мобильный' : isTablet ? 'Планшет' : 'Десктоп';

        ClientTraceContext.setOwnerId(userId);

        dispatch(
            extendFbPayload({
                regionId: getRegionId(region),
                regionName: region.name,
                region_latitude: region.latitude,
                region_longitude: region.longitude,
                region_full_name: region.fullName,
                ...(onMount
                    ? {
                          device_type,
                          sourceUrl: typeof window !== 'undefined' ? window.location.href : undefined,
                          abc_group_creditselection: getSelectionAbExperimentAnalytics(experiments),
                          ...(areExperimentsDefault ? { areExperimentsDefault } : {}),
                      }
                    : {}),
            }),
        );

        dispatch(
            extendFormStore({
                page,
                region,
                userId,
                headline,
                oncePassedSteps,
                disabledFields,
                ...(onMount
                    ? {
                          autoRun,
                          googleAnalyticId,
                          yandexMetricsId,
                          guid,
                      }
                    : {}),
            }),
        );
    };

    render() {
        const { page, requestId, setShowLanding, showProduct, hasUnsignedDocs, isLoggedInSilent } = this.props;
        const { mounted } = this.state;
        const isCallCenterWithGuid = [PAGE.CALLCENTER, PAGE.CALLCENTER_MAIN_FORM_EDIT].includes(page);

        const pagesWithRestrictedProfileUpdateForSilentAuth: Array<string> = [PAGE.RESTORE, PAGE.CARDS_RESTORE];

        const withProfile = () => {
            if (page === PAGE.AVITO) {
                return false;
            }

            return pagesWithRestrictedProfileUpdateForSilentAuth.includes(page) ? !isLoggedInSilent : true;
        };

        if (isCallCenterWithGuid && !requestId) {
            return <NotFound />;
        }

        return (
            <AnchorWrapper id={FORM_NAME}>
                <Wrapper data-ready>
                    {showProduct ? <ProductHeader /> : null}
                    {mounted ? (
                        <View
                            withLocal={!isCallCenterWithGuid}
                            withQuery={!isCallCenterWithGuid}
                            withProfile={withProfile()}
                            setShowLanding={setShowLanding}
                        />
                    ) : (
                        <MainSkeleton />
                    )}
                </Wrapper>
            </AnchorWrapper>
        );
    }
}

const LandingForm = connect<ConnectedProps, object, OwnProps, IGlobalState>((state) => ({
    region: state.locations.currentLocation,
    page: state.selection.page,
    experiments: state.abData.experiments,
    areExperimentsDefault: state.abData.isDefaultVariants,
    hasUnsignedDocs: state.esia.unsignedDocuments.length > 0,
    isLoggedInSilent: state.user.loggedInSilent,
    isLoggedIn: state.user.loggedIn,
}))(LandingFormComponent);

/** use helpers/dynamic.modules */
export default LandingForm;
